// extracted by mini-css-extract-plugin
export default {"reportCommentContainer":"ReportCommentField_reportCommentContainer__xF5LT"};